// ************************************************************************************* //
//   ___ _____ ___  ___  **   ___ _____ ___  ___  **   ___ _____ ___  ___  **
//  / __|_   _/ _ \| _ \ **  / __|_   _/ _ \| _ \ **  / __|_   _/ _ \| _ \ **
//  \__ \ | || (_) |  _/ **  \__ \ | || (_) |  _/ **  \__ \ | || (_) |  _/ **
//  |___/ |_| \___/|_|   **  |___/ |_| \___/|_|   **  |___/ |_| \___/|_|   **
// _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ //
// Do not add new action handlers to this file
// listingRecord should be hydrated once on page load and then never updated again
// Instead, please add any dynamically loaded listing values to listingExtendedRecord
// ************************************************************************************* //

import createReducer from '../utils/createReducer';
import listingActions from '../actions/listingActions';

const initialState = {};

const actionHandlers = {
    [listingActions.FETCH_HOUSE_RULES_SUCCESS](state, {payload}) {
        const {
            houseRules
        } = payload;

        return Object.assign({}, state, {houseRules});
    },
    [listingActions.FETCH_RECOMMENDED_PROPERTIES_SUCCESS](state, {payload}) {
        const {
            recommendedProperties
        } = payload;

        return Object.assign({}, state, {recommendedProperties});
    },
    [listingActions.FETCH_REGISTRATION_NUMBER_SUCCESS](state, {payload}) {
        const {
            registrationNumber
        } = payload;

        const newState = Object.assign({}, state, {registrationNumber});
        return newState;
    }
};

export default createReducer(actionHandlers, initialState);
